import react from "react";
import { createComponent } from "@lit/react";
import { MdPrimaryTab } from "@material/web/tabs/primary-tab";

export const LitPrimaryTab = createComponent({
  tagName: "md-primary-tab",
  elementClass: MdPrimaryTab,
  react
});
